export default defineNuxtPlugin(() => {
  if (!import.meta.client) {
    return
  }

  const url = window.location.href
  const maxAge = 60 * 60 // 1 hour
  const domain = getRootDomain(window.location.hostname)
  document.cookie = `marketing_landing_url=${encodeURIComponent(url)};path=/;max-age=${maxAge};domain=${domain};secure;samesite=lax`
})
